<div class="row" *ngIf="(carrierIncident | json) != '{}'">
    <div class="col-sm-12">
        <div class="row">
            <div class="col">
                <label class="font-weight-bold">Type</label>
                <select name="incidentTypeID" [(ngModel)]="carrierIncident.carrierIncidentTypeID" class="form-select" required>
                    <option *ngFor="let item of carrierIncidentTypeList" value="{{item.carrierIncidentTypeID}}">{{item.abbreviation}} - {{item.description}}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="font-weight-bold">Description</label>
                <input type="text" class="form-control" [(ngModel)]="carrierIncident.incidentDescription" required />
            </div>
        </div>
        <div class="row">
            <div class="col m-2 text-end">
                <button class="btn btn-primary m-2" (click)="save()">Save</button>
                <button class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>

<div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay': isLoading}">
    <mat-spinner style="left: 50%; top: 50%" *ngIf="isLoading"></mat-spinner>
</div>
